import { createFeatureSelector, createSelector } from "@ngrx/store";
import { each } from "lodash";
import { PromotionRequisiteModel } from "./promotion-requisite.model";
import { PromotionRequisitesState } from "./promotion-requisites.reducers";

export const selectRequisitesState = createFeatureSelector<PromotionRequisitesState>("promotion-requisites");

export const selectRequisiteById = (requisiteId: number) =>
  createSelector(selectRequisitesState, (requisitesState) => requisitesState.entities[requisiteId]);

export const selectLastCreatedRequisiteId = createSelector(
  selectRequisitesState,
  (requisitesState) => requisitesState.lastCreatedRequisiteId
);

export const selectRequisitesShowInitWaitingMessage = createSelector(
  selectRequisitesState,
  (requisitesState) => requisitesState.showInitWaitingMessage
);

export const selectRequisitesInStore = createSelector(selectRequisitesState, (requisitesState) => {
  const items: PromotionRequisiteModel[] = [];
  each(requisitesState.entities, (element) => {
    items.push(element);
  });
  return items;
});
